// extracted by mini-css-extract-plugin
var _1 = "OrderDetails_container__cseNO";
var _2 = "OrderDetails_orderName__zIrzP";
var _3 = "OrderDetails_product__MmmhO";
var _4 = "OrderDetails_productsContainer__uHbVk";
export { _1 as "container", _2 as "orderName", _3 as "product", _4 as "productsContainer" }
